module.exports = __webpack_public_path__ + "static/media/history.c41aa96e.svg";